import { NgClass } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
} from "@angular/core";
import { Location } from "@angular/common";
import { RouterLink } from "@angular/router";
import {
  NgbModal,
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownItem,
} from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "src/app/services/auth.service";
import { LoginComponent } from "../form-login/login.component";
import { RegisterComponent } from "../form-register/register.component";
import { AlertHelper } from "src/app/helper/alert.helper";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  imports: [
    NgClass,
    RouterLink,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private modalService = inject(NgbModal);
  private auth = inject(AuthService);
  private alert = inject(AlertHelper);
  private destroyRef = inject(DestroyRef);
  private location = inject(Location);
  isMenuOpen = false;

  closeMenu() {
    this.isMenuOpen = false;
  }
  currentSection = "home";
  status = this.auth.isLoggedIn;
  userDetail = this.auth.userDetail;

  scrollTo(id: string, offset = 0) {
    const element = document.getElementById(id);
    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }

  windowScroll() {
    const navbar = document.getElementById("navbar");
    if (
      document.body.scrollTop >= 50 ||
      document.documentElement.scrollTop > 50
    ) {
      navbar.classList.add("nav-sticky");
    } else {
      navbar.classList.remove("nav-sticky");
    }
  }

  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  loginModal() {
    const modalRef = this.modalService.open(LoginComponent, { centered: true });
    modalRef.componentInstance.modal = modalRef;
  }

  registerModal() {
    const modalRef = this.modalService.open(RegisterComponent, {
      centered: true,
    });
    modalRef.componentInstance.modal = modalRef;
  }

  goBack() {
    this.location.back();
  }

  logout() {
    this.alert.confirm("Apakah Anda yakin ingin keluar?", "").then((result) => {
      if (!result.isConfirmed) return;
      this.auth
        .logout$()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => this.alert.success("Keluar", "Berhasil keluar"),
          error: () => this.alert.error("Logout gagal", "Silakan coba lagi."),
        });
    });
  }
}
